import { Outlet } from 'react-router-dom'
import styles from './MainLayout.module.css'

export function MainLayout() {
  return (
    <div className={styles.wrapper}>
      <Outlet />
    </div>
  )
}
